/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardMedalIcon24Solid = forwardRef('AwardMedalIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m2.764 3.162 3.598 5.476A8.468 8.468 0 0 1 12 6.5c2.163 0 4.137.808 5.638 2.138l3.598-5.476A.75.75 0 0 0 20.61 2h-5.688a.75.75 0 0 0-.641.36L12 6.107 9.718 2.36A.75.75 0 0 0 9.08 2H3.39a.75.75 0 0 0-.626 1.162Z" }),
        React.createElement("path", { d: "M12 22a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z" })));
});
